export const ACTIVITY_COUNTS = [["dials", "Dials/DMs Sent"], ["conversations", "Conversations"], ["declined_to_book", "Declined to Book"]];
export const BLANK_ACTIVITY = { dials: "", conversations: "", declined_to_book: "" };

const countError = (raw) => {
  const n = Number(raw);
  if (!Number.isInteger(n)) return "Enter a whole number";
  if (n < 0) return "Must be 0 or more";
  return null;
};

export const validateActivity = (f) => {
  const e = {};
  ACTIVITY_COUNTS.forEach(([k]) => {
    const err = f[k] === "" ? null : countError(f[k]);
    if (err) e[k] = err;
  });
  if (!e.dials && !e.conversations && Number(f.conversations || 0) > Number(f.dials || 0)) e.conversations = "Conversations can't exceed dials/DMs";
  return e;
};

export const entryToForm = (hit) => (hit
  ? { dials: String(hit.dials), conversations: String(hit.conversations), declined_to_book: String(hit.declined_to_book) }
  : BLANK_ACTIVITY);

export const toActivityBody = (date, setterId, f) => ({
  date, setter_id: setterId, ...Object.fromEntries(ACTIVITY_COUNTS.map(([k]) => [k, Number(f[k] || 0)])),
});
